import { Component, OnInit, LOCALE_ID, Inject } from '@angular/core';
import { CorteService } from 'src/app/services/corte.service';
import { CasetaService } from 'src/app/services/caseta.service';
import { TurnoService } from 'src/app/services/turno.service';
import { EventoService } from 'src/app/services/evento.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';


import { Carril, Caseta, Turno } from 'src/app/models';
import { Turnos } from 'src/app/models/dash';
import {Store} from '@ngrx/store';
import { AppState } from 'src/app/state/app.state';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { formatDate } from '@angular/common';

import { selectUser } from 'src/app/state/selectors/user.selectors';
import { FormatoData, FormatoService } from 'src/app/services/formato.service';
import { RolloService } from 'src/app/services/rollo.service';
import { Observable, Subject } from 'rxjs';

import { TipoVehiculoService } from 'src/app/services/tipo-vehiculo.service';
import { SubtipoCruceService } from 'src/app/services/subtipo-cruce.service';
import { ExentosService } from 'src/app/services/exentos.service';

@Component({
  selector: 'app-dashboard-analista',
  templateUrl: './dashboard-analista.component.html',
  styleUrls: ['./dashboard-analista.component.scss']
})


export class DashboardAnalistaComponent implements OnInit {

  openTab = 1;
  idCorteUsuario=0
  carriles: Carril[];
  turnos: Turnos[];
  cortes: any[];
  cortesDB: any[];
  cortesI: any[];
  user: any;
  id_corte_usuario: number;
  cobrador: string;
  jefeTurno: string;
  incidencias:any[];
  exentos:any[]
  retiros:any[]
  casetas:any[];
  rollos:any[];
  modalEdit=false;
  mostrarTextAreaError=false
  eventoEdit:any=null
  eventoEditBuffer:any=null;
  rowEdit:any = null;
  tipoError=""

  corte: any[];
  aforoTotal: number = 0;
  aforoFinal: number = 0;
  fondoCobrador: number = 0;
  eludido: number = 0;
  exentoResidente: number = 0;
  boletoRecibido: number = 0;
  folioTotal: number = 0;
  noEmitidos: number = 0;
  cancelados: number = 0;
  montonoEmitidos: number = 0;
  montocancelados: number = 0;
  efectivo: any[];
  editFolioModal: boolean = false;
  data$: Observable<FormatoData>;
  id_rollo: number = 0;
  finalise = new Subject();
  //varibles para la edicion de incidencias
  clasificacionesEdit:any = [];
  incidenciasEdit:any = [];
  modalCarril: boolean=false;

  foliosForm = new FormGroup({
    folioInicial: new FormControl('', [Validators.required, Validators.maxLength(8)]),
    folioFinal: new FormControl('', [Validators.required, Validators.maxLength(8)]),
  });

  corteForm = new FormGroup({
    caseta: new FormControl('', Validators.required),
    turno: new FormControl('', Validators.required),
    fecha: new FormControl('2023-5-31', Validators.required),
    formato: new FormControl(this.openTab),
    corte: new FormControl('', Validators.required),
  });
  subtipoPadres=[];
  subtipoCruce=[];
  allExentos=[];
  actualExentos=[];
  ejes:any
  tarjetones:any
  insertarEvento = new FormGroup({
    fecha_hora: new FormControl('0000-00-00 00:00:00', Validators.required),
    id_corte_usuario: new FormControl(0, Validators.required),
    id_subtipo: new FormControl(2, Validators.required),
    id_clasificacion: new FormControl(1, Validators.required),
    id_cat_observacion: new FormControl(null, Validators.required),
    aventoDinero: new FormControl(null, Validators.required),
    cantidad_ejes: new FormControl(null, Validators.required),
    id_vehiculo_exe: new FormControl(null, Validators.required),
    observacion: new FormControl("{\"tipo\" : \"COBRADOR\" , \"observacion\" : \"INSERTADO POR ANALISTA\" }", Validators.required),
  });
getRowClass(row){
  return (row.habilitado == 1)? 'evento-desabilitado':'';
};


  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private eventoService:EventoService,
    private casetaService: CasetaService,
    private turnoService: TurnoService,
    private store: Store<AppState>,
    private toastr: ToastrService,
    private formatoService: FormatoService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private rolloService: RolloService,
    private corteService: CorteService,
    private vehiculoService: TipoVehiculoService,
    private subtipoCruceService: SubtipoCruceService,
    private exentosService: ExentosService
    ) { this.data$ = formatoService.obtenerData;}



    ngOnInit(): void {
      this.store.select(selectUser).subscribe(async (user) => {
        this.user = user;
        this.corteForm = new FormGroup({
          caseta: new FormControl(this.user.caseta_usuario[0].id, Validators.required),
          turno: new FormControl('3', Validators.required),
          fecha: new FormControl('2023-5-31', Validators.required),
          formato: new FormControl(this.openTab),
          corte: new FormControl('', Validators.required),
        });
        this.casetaService.getCaseta( this.user.caseta_usuario[0].id ).subscribe( caseta => {
          this.carriles = caseta.carriles;
        })
      });

      this.turnoService.getTurnos().subscribe( turnos => {
        this.turnos = turnos;
      });

      this.corteService.getCasetas().subscribe( casetas => {
        this.casetas = casetas;
      });

      this.subtipoCruceService.getSubtipos().subscribe((subtiposPadre)=>{
        this.ejes=subtiposPadre[0].childrens;

        this.subtipoPadres=subtiposPadre.filter((item) => (item.id < 34 || item.id > 60))
        .map((padre)=>{
          if(!padre.childrens ||  padre.childrens.length === 0){
            return{
              ...padre,
              childrens:[padre]} //si el padre no tiene hijos se le asigna a si mismo.
            } else {
              return padre;}
            }
          )
          console.log(this.subtipoPadres);
          /*
          this.subtipoPadres.forEach((padre)=>{
            padre.childrens.forEach((cruce)=>this.subtipoCruce.push(cruce))
            console.log(this.subtipoPadres);
            console.log(this.subtipoCruce);
            })

      */
    });

    this.getTipoVehiculo();
    this.getSubtiposCruce();
    this.getCortes();
    //Obteniendo Los Exentos
    this.getExentos();
    //Cambiar
    this.insertarEvento.get('id_cat_observacion')?.valueChanges.subscribe(idPadre => {
      const padres = this.subtipoPadres.find(padre => padre.id == idPadre);
      this.subtipoCruce = padres?.childrens || [];
      //aqui va el codigo de filtrado de tarjetones
      this.actualExentos = this.allExentos.filter((item) => item.id_tipo_pase == idPadre);

      this.insertarEvento.get('id_subtipo')?.setValue(null);
      this.insertarEvento.get('id_vehiculo_exe')?.setValue(null);
    });
  }
  onSearchChange(event){

  }
  setOpenTab(val){
    this.openTab=val;
    this.incidencias=[]
    this.exentos=[]
    this.retiros=[]
    this.cortes=[];
    this.rollos=[]
  }

  getCaseta() {
    this.casetaService.getCaseta( this.corteForm.value.caseta ).subscribe( caseta => {
      this.carriles = caseta.carriles;
    });
  }

  buscar(){
    this.corteForm.value.formato=this.openTab
    let formObj = this.corteForm.getRawValue(); // {name: '', description: ''}
    this.incidencias=[];
    this.exentos=[];
    this.retiros=[];
    this.cortes=[];
    //console.log(this.corteForm.getRawValue())
    this.ngxUiLoaderService.start();
    switch(this.openTab){
      case 1://get incidencias
          this.corteService.getCorteIncidencias(formObj).subscribe( incidencias => {
            this.incidencias = incidencias;
            console.log(incidencias);
            this.ngxUiLoaderService.stop();
          });
        break;
      case 2://exentos
        this.corteService.getExentos( formObj ).subscribe( exentos => {
          this.exentos = exentos;

          this.ngxUiLoaderService.stop();
        })
        break;
      case 3://cortes
          this.corteService.getCorteCorteAnalista( formObj ).subscribe( corte => {
            //console.log( corte );
            this.rollos = corte['rollo_consumo'];
            this.efectivo = corte['efectivo'];

            // fondo cobrador
            this.fondoCobrador = corte['fondo_cobrador'];

            // folios consumidos
            for (let rollo of this.rollos) {
              this.folioTotal += ((rollo.folio_final - rollo.folio_inicial) + 1);
            }
            this.noEmitidos = corte['folio_consumido'][0].noemitido;
            this.cancelados = corte['folio_consumido'][0].cancelado;
            this.montonoEmitidos = corte['folio_consumido'][0].montonoemitido;
            this.montocancelados = corte['folio_consumido'][0].montocancelado;
            this.aforoTotal = this.folioTotal + (this.noEmitidos - this.cancelados);

            // concentrado de aforo
            this.exentoResidente = corte['aforo'].exentoResidente;
            this.eludido = corte['aforo'].eludido;
            this.boletoRecibido = corte['aforo'].boletoRecibido;
            this.aforoFinal = this.aforoTotal + this.exentoResidente + this.eludido + this.boletoRecibido;
          });

          this.ngxUiLoaderService.stop();


        // this.corteService.getCorteCorteAnalista( formObj ).subscribe( corte => {
        //   console.log( corte );
        //   this.rollos = corte['rollo_consumo'];


        //   // this.aforoFinal = this.aforoTotal + this.exentoResidente + this.eludido + this.boletoRecibido;


        // });
        break;
      case 4://retiros
        this.corteService.getCorteRetirosAnalista( formObj ).subscribe( retiros => {
          this.retiros = retiros;

          this.ngxUiLoaderService.stop();
        });
        break;
    }

    this.ngxUiLoaderService.stop();
  }
  getSubDeteccion(event,valor, clase){
    let elementos=document.getElementsByClassName(clase)
    for (let index = 0; index < elementos.length; index++) {
      elementos[index].classList.remove("text-white")
      elementos[index].classList.remove("bg-blue-800")
      elementos[index].classList.remove("dark:bg-blue-800")
      elementos[index].classList.remove('dark:text-white')
      elementos[index].classList.add('dark:text-gray-500')
      elementos[index].classList.remove("selected")
    }

    event.target.classList.add('text-white')
    event.target.classList.add('bg-blue-800')
    event.target.classList.add('dark:bg-blue-800')
    event.target.classList.add('dark:text-white')
    event.target.classList.add('selected')
    if (clase=='estado') {
      this.mostrarTextAreaError=valor
    }
    if(clase=='error'){
      this.tipoError=valor
    }

  }
  openModelEdit(registro,event){
    let checked=registro.observacion==null;
    //registro.observacion = '{"tipo" : "USUARIO" , "observacion" : "TEST TEST TEST" }';
    if(event.target.checked){
      //si es correcto
      let formObservacion=new FormGroup({
        id: new FormControl(registro.id, Validators.required),
      });
      this.corteService.actualizarObservacionEvento( formObservacion.getRawValue() ).subscribe();
      //finalmente reset evento
      this.eventoEdit=null;
    }else{
      //incorrecto mostrar modal
      //console.log('abrir modal')
      this.modalEdit=true;
      let registroBuffer = (registro)? registro:null;
      this.eventoEdit=registro;
      this.eventoEditBuffer = registroBuffer;
      //console.log(this.eventoEdit);
      if (this.eventoEdit.tarifa == null){ this.eventoEdit.tarifaId = 0};
      if (this.eventoEdit.descripcionId == null){this.eventoEdit.descripcionId = 0};
      let identificador =  this.clasificacionesEdit.filter(clasificacion => clasificacion.tipo == this.eventoEdit.tarifa);
      this.rowEdit = registro;
      //console.log(this.eventoEdit);

    }




    //reset opciones de error
      // let elementos=document.getElementsByClassName("error")
      // for (let index = 0; index < elementos.length; index++) {
      //   elementos[index].classList.remove("text-white")
      //   elementos[index].classList.remove("bg-blue-800")
      //   elementos[index].classList.remove("dark:bg-blue-800")
      //   elementos[index].classList.remove('dark:text-white')
      //   elementos[index].classList.add('dark:text-gray-500')
      //   elementos[index].classList.remove("selected")
      // }
      // if (cadena.length>0){
      //   //parse cxadena a jsonng ser
      //   let observacion=JSON.parse(cadena);
      //   //identificar opcion correcta
      //   var btnError=document.getElementsByClassName(observacion.tipo)
      //   //mostrar seccionado la opcion de DB
      //   btnError[0].classList.add('text-white')
      //   btnError[0].classList.add('bg-blue-800')
      //   btnError[0].classList.add('dark:bg-blue-800')
      //   btnError[0].classList.add('dark:text-white')
      //   btnError[0].classList.add('selected')
      //   this.observacionEdit=observacion.observacion
      // }else{
      //   this.observacionEdit=""
      // }
    return checked;
  }



  formateoObservacion(cadena){
    if (cadena.length>0){
      let observacion=JSON.parse(cadena);
      return observacion.tipo+": "+observacion.observacion;
    }else{
      return ""
    }
  }
  dismissModal(bandera, registro?){
    if (bandera){
      let fechaHora = new Date();
      let stringFH = fechaHora.toString();
      switch(this.openTab){
        case 1: case 2: //incidencias y exentos
        let observacionEdit=document.getElementById("observacionEdit") as HTMLInputElement;
        let formObservacion=new FormGroup({
            id: new FormControl(this.eventoEdit.id, Validators.required),
            habilitado: new FormControl(this.eventoEdit.habilitado),
            tipo_vehiculo: new FormControl(this.eventoEdit.tarifaId),
            incidencia: new FormControl(this.eventoEdit.descripcionId),
            observacion: new FormControl('{"tipo" : "'+this.tipoError +
              '" , "observacion" : "' + observacionEdit.value +
              '" }', Validators.required),
            evento_anterior: new FormControl('{' +
              '"habilitado" : "'+ this.eventoEditBuffer.habilitado +
              '" , "tipo_vehiculo" : "' + this.eventoEditBuffer.tarifaId  +
              '" , "incidencia" : "' + this.eventoEditBuffer.descripcionId  +
              '" , "observacion" : "' + this.eventoEditBuffer.observacion  + ' ' + stringFH +
              '" }')
          });
          this.corteService.actualizarObservacionEvento( formObservacion.getRawValue() ).subscribe();
          //finalmente reset evento
          //console.log(formObservacion.getRawValue());
          this.eventoEdit.observacion = '{"tipo" : "'+this.tipoError +
              '" , "observacion" : "' + observacionEdit.value +
              '" }';
          this.resetEditModal(this.eventoEdit);
          //this.buscar();
          this.eventoEdit=null;
          //console.log(this.incidencias);
          break;
        case 3: case 4:

          break;
      }
    }



    //ocultar modal
    this.modalEdit=false;
  }
  resetEditModal(editFinal) {
    let indice = this.incidencias.findIndex(incide => incide.id == editFinal.id);
    let indiceClasificacion = this.clasificacionesEdit.findIndex(clas => clas.id == editFinal.tarifaId);
    let indiceIncidencia = this.incidenciasEdit.findIndex(inci => inci.id == editFinal.descripcionId);
    let observacionEdit=document.getElementById("observacionEdit") as HTMLInputElement;
    this.incidencias[indice] = {...this.incidencias[indice],
      id: editFinal.id,
      habilitar: editFinal.habilitado,
      tarifa: this.clasificacionesEdit[indiceClasificacion].tipo,
      tarifaId: editFinal.tarifaId,
      descripcion: this.incidenciasEdit[indiceIncidencia].nombre,
      descripcionId: editFinal.descripcionId,
      observacion: '{"tipo" : "'+this.tipoError +
              '" , "observacion" : "' + observacionEdit.value +
              '" }'
    };

    this.incidencias = [...this.incidencias];

    // switch (tab) {
    //   case 1:
    //     this.incidencias = {...this.incidencias};
    //     break;
    //   case 2:
    //     this.exentos = {...this.exentos};
    //       break;
    //   default:
    //     break;
    // }
  }

  exportar(reporte){
    this.ngxUiLoaderService.start();
    let data=this.corteForm.getRawValue();
    data.formato=reporte
    let tiposReporte= [ "Reporte-incidencias", "Registro-exentos-residentes", "Corte-caja", "Retiros-parciales"]
    // let data = {
    //   "form": this.corteForm.getRawValue(),
    //   "formato": reporte
    // }
    this.corteService.getDataReporteAnalista(data)
      .then((data: any) => {
          let downloadURL = window.URL.createObjectURL(data);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = tiposReporte[(reporte - 1)]+"_"+this.corteForm.value.fecha+".pdf";
          link.click();
          this.ngxUiLoaderService.stop();
          this.toastr.success('Se ha descargado el documento con éxito', '', { positionClass: 'toast-bottom-right' })

        // if (download) {} else {
        //   this.base64Reporte = data + '#toolbar=0'; //Eliminar cabecera de iframe
        //   this.openModal();//abrir el modal
        //   this.ngxUiLoaderService.stop();
        // }
      }).catch((err) => {
        this.toastr.error("Por favor inténtalo nuevamente", "Se ha producido un error", { positionClass: 'toast-bottom-right' })
        this.ngxUiLoaderService.stop();
      });
  }





  getRolloId(id_rollo: number) {
    this.id_rollo = id_rollo;
    //console.log( 'Rollo ID', id_rollo );
  }

  updateFolios() {
    if (!this.foliosForm.valid) { return this.toastr.error('Por favor, ingrese los folios', 'Error', { positionClass: 'toast-bottom-right' } ) }

    let data = {
      id: this.id_rollo,
      folio_inicial: Number(this.foliosForm.value.folioInicial),
      folio_final: Number(this.foliosForm.value.folioFinal)
    }

    this.ngxUiLoaderService.start();

    this.rolloService.updateFolios( data ).subscribe( data => {

      this.toastr.success('Se actualizaron los folios del corte', '', {positionClass: 'toast-bottom-right'});
      this.editFolioModal= false;

      window.location.reload()

      this.ngxUiLoaderService.stop();

    });
    this.ngxUiLoaderService.stop();

    // console.log( data, "DATA ACTUALIZADA" );
  }

  getTipoVehiculo(){
    this.vehiculoService.getClasificacionVehiculo()
    .subscribe(resultado => {
      let jsonZero = {
        "clasificacion" : "Sin Tarifa",
        "icon" : "",
        "id" : 0,
        "tipo":"Sin Tarifa"
      }
      this.clasificacionesEdit = resultado;
      this.clasificacionesEdit.push(jsonZero);
      console.log(this.clasificacionesEdit);
    });
   }

  getSubtiposCruce(){
    this.subtipoCruceService.getSubtipoChilds()
    .subscribe(salida => {
        let jsonZeo = {
          "id" : 0,
          "nombre":"Sin Evento"
        }
        this.incidenciasEdit =  salida;
        this.incidenciasEdit.push(jsonZeo);
      });
  }

  abrirCarril(){
    let valor = this.checkCorteSeleccionado();
    console.log('el valor de corte es: ', valor);
    if(!valor){
      return this.toastr.info(`No ha seleccionado ningun corte`, '', { positionClass: 'toast-bottom-right' })
    }
    if(this.cortesDB.length == 0){
      return this.toastr.info(`No existe corte para agregar`, '', { positionClass: 'toast-bottom-right' })
    } else{

      console.log(this.cortesDB);
      this.cortesI = this.cortesDB.filter((item)=> Number(item.id) === Number(valor));
      console.log(this.cortesI);
    }

    let optionCorte = this.insertarEvento.get('id_corte_usuario');
    let optionFecha = this.insertarEvento.get('fecha_hora');
    optionFecha.setValue(this.cortesI[0].fecha_hora_inicio);
    optionCorte.setValue(valor);
    /*
    this.corteService.cortesPorFechaCasetaTurno(this.corteForm.getRawValue()).subscribe(cortes => {
      if (!cortes.length) {
        //this.corteFormReset(1);
        this.ngxUiLoaderService.stop()
        return this.toastr.info(`No existen cortes para esta configuracion`, '', { positionClass: 'toast-bottom-right' })
      }
      this.cortesI = cortes.filter((item)=>item.carril.id==this.corteForm.value.carril);
    });
    */

    this.modalCarril=true
  }
  insertarEventoF(){
    this.eventoService.saveEvento(this.insertarEvento.value).subscribe((data)=>{
      this.modalCarril=false
      console.log(data)
    });

  }
  getCortes(){
    this.corteService.cortesPorFechaCasetaTurno(this.corteForm.getRawValue()).subscribe(cortes => {
      console.log(cortes)
      if (!cortes.length) {
        return this.toastr.info(`No existen cortes para esta configuracion`, '', { positionClass: 'toast-bottom-right' })
      }
      this.cortesDB = cortes;
    });
  }

  checkCorteSeleccionado(){
    const corteSeleccionado = this.corteForm.get('corte');
    if(corteSeleccionado){
      const valor = corteSeleccionado.value;
      if(valor !== null || valor !== ''){
        return valor;
      }else{
        return false;
      }
    }else{
      return false;
    }
  }



  async getExentos() {
    try {
      this.exentosService.getExentos().subscribe((vehiculos)=>{
        this.allExentos = vehiculos;
       });
    } catch (error) {
        this.toastr.error('Error al obtener los registros', 'favor de intentar de nuevo', { positionClass: 'toast-bottom-right' });
    }
  }
}
